import React from "react";
export const Photo3Shape = ({ image }) => {
  return (
    <svg 
      width="100%" 
      height="100%" 
      viewBox="0 0 200 200" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
    >
      <defs>
        <linearGradient id="photo3Gradient1" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="#D9D9D9" />
          <stop offset="100%" stopColor="rgba(134, 131, 131, 0)" />
        </linearGradient>
        
        <linearGradient id="photo3Gradient2" x1="0%" y1="0%" x2="0%" y2="100%">
          <stop offset="0%" stopColor="rgba(0, 0, 0, 0)" />
          <stop offset="32.53%" stopColor="rgba(0, 0, 0, 0)" />
          <stop offset="95.18%" stopColor="rgba(46, 0, 0, 0.89)" />
        </linearGradient>
        
        <clipPath id="photo3Clip">
          <path d="M100.72 0.5C154.86 0.500005 198.75 44.3897 198.75 98.5303V198.75H95.6846C43.1155 198.75 0.5 156.134 0.5 103.564V100.72C0.5 45.3699 45.3699 0.5 100.72 0.5Z" />
        </clipPath>
      </defs>
      
      <path 
        d="M100.72 0.5C154.86 0.500005 198.75 44.3897 198.75 98.5303V198.75H95.6846C43.1155 198.75 0.5 156.134 0.5 103.564V100.72C0.5 45.3699 45.3699 0.5 100.72 0.5Z" 
        fill="url(#photo3Gradient1)" 
        stroke="black"
        strokeWidth="1"
      />
      
      <path 
        d="M100.72 0.5C154.86 0.500005 198.75 44.3897 198.75 98.5303V198.75H95.6846C43.1155 198.75 0.5 156.134 0.5 103.564V100.72C0.5 45.3699 45.3699 0.5 100.72 0.5Z" 
        fill="url(#photo3Gradient2)"
      />
      
      <image
        href={image}
        x="0"
        y="0"
        width="200"
        height="200"
        clipPath="url(#photo3Clip)"
        preserveAspectRatio="xMidYMid slice"
      />
    </svg>
  );
};
export default Photo3Shape;